module.exports = __webpack_public_path__ + "fonts/helvetica-now-display-regular.671f20f.woff2";